module.exports = __webpack_public_path__ + "static/media/assessment-no-data.270078f9.svg";